import {createFileRoute, SearchSchemaInput} from '@tanstack/react-router';

import ConnectWhatsAppView from '../user/ConnectWhatsAppView.tsx';

export const Route = createFileRoute('/connect-whatsapp')({
    validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => ({
        token: typeof search.token === 'string' ? search.token : '',
    }),
    component: RouteComponent,
});

function RouteComponent() {
    const {token} = Route.useSearch();

    return <ConnectWhatsAppView token={token} />;
}
